// import React, { useState } from "react";
import "../styles/footer.css";
import vinnovaLogo from "../assets/img/vinnova_logo.svg";


const Footer = () => {
//   const [showCookiesModal, setShowCookiesModal] = useState(false);

  return (
    <footer className="site-footer" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>

      {/* Funding / Support strip */}
      <div className="footer-support">
        <div className="container">
          <div className="support-grid">
            <p className="support-text">
              ProMS receives support from <strong>Vinnova, Sweden’s Innovation Agency</strong> under the call ‘Precision Medicine of the Future (Framtidens Precisionsmedicin)’
            </p>
            <div className="support-logos">
				<a href="https://www.vinnova.se/en/" target="_blank" rel="noopener noreferrer">
					<img
						src={vinnovaLogo}
						alt="Vinnova"
						height="32"
					/>
				</a>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand / Mission */}
            <div className="footer-col footer-brand">
              <div className="brand-title">ProMS</div>
              <p>
                Integrating proteomics into precision medicine to enable better
                diagnostics, treatment selection, and patient outcomes.
              </p>
              <div className="footer-social">
                {/* Add your social links if needed */}
                {/* <a href="#"><img src={facebookIcon} alt="Facebook" /></a>
                <a href="#"><img src={linkedinIcon} alt="LinkedIn" /></a> */}
              </div>
            </div>

            {/* Quick links (optional—replace with your routes) */}
            <nav className="footer-col footer-links" aria-label="Footer navigation">
              <h4>Explore</h4>
              <ul>
                <li><a href="/aims">Aims</a></li>
                <li><a href="/collaborators">Collaborators</a></li>
                <li><a href="/project">Project</a></li>
              </ul>
            </nav>

            {/* Contact */}
            <div className="footer-col footer-contact">
              <h4>Contact</h4>
              <ul>
                <li>Prof. Janne Lehtiö — <a href="mailto:janne.lehtio@ki.se">janne.lehtio@ki.se</a></li>
                <li>Helena Bäckvall — <a href="mailto:helena.backvall@ki.se">helena.backvall@ki.se</a></li>
                <li>Xenia Villalobos Alberú — <a href="mailto:xenia.villalobos.alberu@ki.se">xenia.villalobos.alberu@ki.se</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom line
      <div className="footer-bottom">
        <div className="container bottom-grid">
          <p>© {new Date().getFullYear()} ProMS. All rights reserved.</p>
          <button
            className="cookies-button"
            onClick={() => setShowCookiesModal(true)}
            aria-haspopup="dialog"
          >
            Cookie Preferences
          </button>
        </div>
      </div>

      {showCookiesModal && (
        <div className="cookies-modal" role="dialog" aria-modal="true" aria-label="Cookie preferences">
          <div className="cookies-modal-content">
            <h4>Cookie Preferences</h4>
            <p>
              We use cookies to improve your experience. You can accept all cookies or
              customize your preferences.
            </p>
            <div className="cookies-modal-buttons">
              <button onClick={() => setShowCookiesModal(false)}>Accept All</button>
              <button onClick={() => setShowCookiesModal(false)}>Customize</button>
            </div>
          </div>
        </div>
      )} */}
    </footer>
  );
};

export default Footer;
